// extracted by mini-css-extract-plugin
export default {"iconWrapper":"ToolIcon_iconWrapper__O4n-A","iconWrapper__large":"ToolIcon_iconWrapper__large__6-UE+","iconWrapper__small":"ToolIcon_iconWrapper__small__vKb7m"};